<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4
            slot="header"
            class="card-title text-left"
            style="padding: 0px; margin: 0px;"
          >
            Adicionar Nova Escala
          </h4>
          <div style="margin-top: 20px;">
            <div class="row">
              <div class="col-md-3 text-left">
                <h4 slot="header" class="card-title">Código</h4>
                <input
                  type="number"
                  class="form-control"
                  placeholder="Código"
                  @blur="verificarCodigo"
                  v-model="codigo"
                />
              </div>
              <div class="col-md-3 text-left">
                <h4 slot="header" class="card-title">Descrição</h4>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Descrição"
                  v-model="descricao"
                />
              </div>
              <div class="col-md-3 text-left">
                <h4 slot="header" class="card-title">Departamento</h4>
                <base-input>
                  <el-select
                    class="select-success"
                    size="large"
                    placeholder="Single Select"
                    v-model="departamento"
                  >
                    <el-option
                      v-for="item in listDepartamentos"
                      :key="item.id"
                      class="select-success"
                      :label="item.descricao"
                      :value="item.id"
                      >{{ item.descricao }}</el-option
                    >
                  </el-select>
                </base-input>
              </div>
              <div class="col-md-3 text-left">
                <h4 slot="header" class="card-title">Quantidades de Colunas</h4>
                <base-input>
                  <el-select
                    class="select-success"
                    size="large"
                    placeholder="Single Select"
                    v-model="qtdColunasSelecionadas"
                  >
                    <el-option class="select-success" label="2" value="2"
                      >2</el-option
                    >
                    <el-option class="select-success" label="4" value="4"
                      >4</el-option
                    >
                    <el-option class="select-success" label="6" value="6"
                      >6</el-option
                    >
                    <el-option class="select-success" label="8" value="8"
                      >8</el-option
                    >
                  </el-select>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 text-left">
                <h4 slot="header" class="card-title">
                  Selecione os dia do horário
                </h4>
                <div class="d-flex flex-row justify-content-between">
                  <base-checkbox v-model="allDias">Todos os dias</base-checkbox>
                  <base-checkbox v-model="domingo" v-show="!allDias"
                    >Domingo</base-checkbox
                  >
                  <base-checkbox v-model="segunda" v-show="!allDias"
                    >Segunda</base-checkbox
                  >
                  <base-checkbox v-model="terca" v-show="!allDias"
                    >Terça</base-checkbox
                  >
                  <base-checkbox v-model="quarta" v-show="!allDias"
                    >Quarta</base-checkbox
                  >
                  <base-checkbox v-model="quinta" v-show="!allDias"
                    >Quinta</base-checkbox
                  >
                  <base-checkbox v-model="sexta" v-show="!allDias"
                    >Sexta</base-checkbox
                  >
                  <base-checkbox v-model="sabado" v-show="!allDias"
                    >Sábado</base-checkbox
                  >
                </div>
              </div>
            </div>

            <div class="row" style="margin-top: 10px;">
              <div class="col-md-3 text-left">
                <h4 slot="header" class="card-title">Entrada / Saída 1</h4>
                <div class="d-flex flex-row justify-content-between">
                  <input
                    type="time"
                    class="form-control"
                    placeholder="Data Inicial"
                    style="margin: 0px 5px 0px 0px;"
                    v-model="entrada1"
                  />
                  <input
                    type="time"
                    class="form-control"
                    placeholder="Data Inicial"
                    style="margin: 0px 0px 0px 5px;"
                    v-model="saida1"
                  />
                </div>
              </div>
              <div
                class="col-md-3 text-left"
                v-show="qtdColunasSelecionadas == 2"
              >
                <h4 slot="header" class="card-title">Descanso</h4>
                <div class="d-flex flex-row justify-content-between">
                  <input
                    type="time"
                    class="form-control"
                    placeholder="Descanso"
                    style="margin: 0px 5px 0px 0px;"
                    v-model="descanso"
                  />
                </div>
              </div>
              <div
                class="col-md-3 text-left"
                v-show="
                  qtdColunasSelecionadas == 4 ||
                    qtdColunasSelecionadas == 6 ||
                    qtdColunasSelecionadas == 8
                "
              >
                <h4 slot="header" class="card-title">Entrada / Saída 2</h4>
                <div class="d-flex flex-row justify-content-between">
                  <input
                    type="time"
                    class="form-control"
                    placeholder="Data Inicial"
                    style="margin: 0px 5px 0px 0px;"
                    v-model="entrada2"
                  />
                  <input
                    type="time"
                    class="form-control"
                    placeholder="Data Inicial"
                    style="margin: 0px 0px 0px 5px;"
                    v-model="saida2"
                  />
                </div>
              </div>
              <div
                class="col-md-3 text-left"
                v-show="
                  qtdColunasSelecionadas == 6 || qtdColunasSelecionadas == 8
                "
              >
                <h4 slot="header" class="card-title">Entrada / Saída 3</h4>
                <div class="d-flex flex-row justify-content-between">
                  <input
                    type="time"
                    class="form-control"
                    placeholder="Data Inicial"
                    style="margin: 0px 5px 0px 0px;"
                    v-model="entrada3"
                  />
                  <input
                    type="time"
                    class="form-control"
                    placeholder="Data Inicial"
                    style="margin: 0px 0px 0px 5px;"
                    v-model="saida3"
                  />
                </div>
              </div>
              <div
                class="col-md-3 text-left"
                v-show="qtdColunasSelecionadas == 8"
              >
                <h4 slot="header" class="card-title">Entrada / Saída 4</h4>
                <div class="d-flex flex-row justify-content-between">
                  <input
                    type="time"
                    class="form-control"
                    placeholder="Data Inicial"
                    style="margin: 0px 5px 0px 0px;"
                    v-model="entrada4"
                  />
                  <input
                    type="time"
                    class="form-control"
                    placeholder="Data Inicial"
                    style="margin: 0px 0px 0px 5px;"
                    v-model="saida4"
                  />
                </div>
              </div>
            </div>

            <div class="row" style="margin-top: 10px;">
              <div class="col-md-12">
                <div class="d-flex justify-content-end">
                  <base-button
                    type="success"
                    class="animation-on-hover"
                    style="margin: 0px 5px 0px 5px;"
                    :disabled="disabledBtnSalvar()"
                    @click="cadastrarEscalasDepartamentos()"
                    >Salvar</base-button
                  >
                </div>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import users from "../../../pages/Tables/users.js";
import swal from "sweetalert2";
import Fuse from "fuse.js";
// import NotificationHorarioLimite from "../Notifications/NotificationHorarioLimite.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "cadastrar-escalas",
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
  },

  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      listDepartamentos: [],
      allDias: false,
      domingo: false,
      segunda: false,
      terca: false,
      quarta: false,
      quinta: false,
      sexta: false,
      sabado: false,
      entrada1: "",
      entrada2: "",
      entrada3: "",
      entrada4: "",
      saida1: "",
      saida2: "",
      saida3: "",
      saida4: "",
      descanso: "",
      intervaloInicial: "",
      intervaloFinal: "",
      horarioSelecionado: "",
      escalaManual: 1,
      departamento: "",
      qtdColunasSelecionadas: 4,
      codigo: "",
      descricao: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      isLoading: false,
      dialogHorarioLimite: false,
      searchQuery: "",
      propsToSearch: ["name", "email", "age"],
      tableColumns: [
        {
          prop: "name",
          label: "Name",
          minWidth: 200,
        },
        {
          prop: "email",
          label: "Email",
          minWidth: 250,
        },
        {
          prop: "age",
          label: "Age",
          minWidth: 100,
        },
        {
          prop: "salary",
          label: "Salary",
          minWidth: 120,
        },
      ],
      tableData: users,
      searchedData: [],
      fuseSearch: null,
    };
  },
  mounted() {
    this.listarDepartamento();
    // this.notifyVue('top', 'center');
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "email"],
      threshold: 0.3,
    });
  },
  methods: {
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 2000,
          showConfirmButton: false,
        });
      }
    },

    cadastrarEscalasDepartamentos() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        codigo: this.codigo,
        descricao: this.descricao,
        dia_da_semana: "",
        entrada_1: this.entrada1,
        saida_1: this.saida1,
        entrada_2: this.entrada2,
        saida_2: this.saida2,
        entrada_3: this.entrada3,
        saida_3: this.saida3,
        entrada_4: this.entrada4,
        saida_4: this.saida4,
        // pre_assinalado_intervalo_1: this.descanso,
        // pre_assinalado_intervalo_2: this.descanso,
        id_departamento: this.departamento,
        segunda_feira: this.segunda ? "S" : "N",
        terca_feira: this.terca ? "S" : "N",
        quarta_feira: this.quarta ? "S" : "N",
        quinta_feira: this.quinta ? "S" : "N",
        sexta_feira: this.sexta ? "S" : "N",
        sabado: this.sabado ? "S" : "N",
        domingo: this.domingo ? "S" : "N",
        todos_dias: this.allDias ? "S" : "N",
        descanso: this.descanso,
      };

      if (this.entrada2 === "") {
        delete bodyFormData.entrada_2;
      }

      if (this.entrada3 === "") {
        delete bodyFormData.entrada_3;
      }

      if (this.entrada4 === "") {
        delete bodyFormData.entrada_4;
      }

      if (this.saida2 === "") {
        delete bodyFormData.saida_2;
      }

      if (this.saida3 === "") {
        delete bodyFormData.saida_3;
      }

      if (this.saida4 === "") {
        delete bodyFormData.saida_4;
      }

      this.axios
        .post(
          "/api/escalas/cadastrarModeloDeEscalasDepartamento",
          bodyFormData,
          {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          },
        )
        .then((response) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Escala cadastrada com sucesso!",
            "success",
          );
          setTimeout(() => {
            th.$router.push("/pesquisarEscalaDepartamento");
          }, 2000);
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar departamentos!",
            "error",
          );
        });
    },

    disabledBtnSalvar() {
      if (!this.codigo || !this.descricao || !this.descricao) {
        return true;
      } else {
        if (this.allDias) {
          if (
            this.qtdColunasSelecionadas == 2 &&
            this.entrada1 &&
            this.saida1 &&
            this.descanso
          ) {
            return false;
          } else if (
            this.qtdColunasSelecionadas == 4 &&
            this.entrada1 &&
            this.saida1 &&
            this.entrada2 &&
            this.saida2
          ) {
            return false;
          } else if (
            this.qtdColunasSelecionadas == 6 &&
            this.entrada1 &&
            this.saida1 &&
            this.entrada2 &&
            this.saida2 &&
            this.entrada3 &&
            this.saida3
          ) {
            return false;
          } else if (
            this.qtdColunasSelecionadas == 8 &&
            this.entrada1 &&
            this.saida1 &&
            this.entrada2 &&
            this.saida2 &&
            this.entrada3 &&
            this.saida3 &&
            this.entrada4 &&
            this.saida4
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          if (
            this.domingo ||
            this.segunda ||
            this.terca ||
            this.quarta ||
            this.quinta ||
            this.sexta ||
            this.sabado
          ) {
            if (
              this.qtdColunasSelecionadas == 2 &&
              this.entrada1 &&
              this.saida1 &&
              this.descanso
            ) {
              return false;
            } else if (
              this.qtdColunasSelecionadas == 4 &&
              this.entrada1 &&
              this.saida1 &&
              this.entrada2 &&
              this.saida2
            ) {
              return false;
            } else if (
              this.qtdColunasSelecionadas == 6 &&
              this.entrada1 &&
              this.saida1 &&
              this.entrada2 &&
              this.saida2 &&
              this.entrada3 &&
              this.saida3
            ) {
              return false;
            } else if (
              this.qtdColunasSelecionadas == 8 &&
              this.entrada1 &&
              this.saida1 &&
              this.entrada2 &&
              this.saida2 &&
              this.entrada3 &&
              this.saida3 &&
              this.entrada4 &&
              this.saida4
            ) {
              return false;
            } else {
              return true;
            }
          } else {
            return true;
          }
        }
      }
    },

    listarDepartamento() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/departamento/listarDepartamentos", bodyFormData)
        .then((response) => {
          th.isLoading = false;
          th.listDepartamentos = response.data.data.dados;
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar departamentos!",
            "error",
          );
        });
    },
    /* notifyVue(verticalAlign, horizontalAlign) {
        this.$notify({
            component: NotificationHorarioLimite,
            icon: "tim-icons icon-bell-55",
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: "warning",
            timeout: 30000
        });
    } */
    verificarCodigo() {
      const codigo = this.codigo;

      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        codigo: codigo,
      };

      this.axios
        .post(
          "/api/escalas/verificarCodigoExistenteEscalaDepartamento",
          bodyFormData,
          {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          },
        )
        .then((response) => {
          th.isLoading = false;

          if (response.data.data.dados[0].PODE_CADASTRAR == "S") {
            th.codigo = codigo;
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Este Código já possui cadastro!",
              "error",
            );
            th.codigo = "";
          }
        })
        .catch((err) => {
          console.log(err);
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Este Código já possui cadastro!",
            "error",
          );
          th.codigo = "";
        });
    },
  },
  watch: {
    qtdColunasSelecionadas(newVal) {
      if (newVal == 2) {
        this.entrada2 = "";
        this.entrada3 = "";
        this.saida2 = "";
        this.saida3 = "";
      } else if (newVal == 4) {
        this.entrada3 = "";
        this.saida3 = "";
        this.descanso = "";
      } else {
        this.descanso = "";
      }
    },
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
